export default [
  {
    path: '/fo/join/termsSheet/:division'
    , name: '약관동의'
    , component: () => import('@/page/account/AgreeToTermsCond.vue')
  },
  {
    path: '/fo/nickNameJoin',
    name: '닉네임 가입',
    component: () => import('@/page/account/NickNameJoin.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '내정보',
    }
  },
  {
    path: '/fo/join/joinEmail',
    name: '이메일 가입',
    component: () => import('@/page/account/JoinEmail.vue'),
  },
  {
    path: '/fo/join/login',
    name: '로그인',
    component: () => import('@/page/account/Login.vue'),
  },
  {
    path: '/fo/join/phoneAuthentication',
    name: '휴대폰 인증',
    component: () => import('@/page/account/PhoneAuthentication.vue'),
  },

  {
    path: '/fo/join/joinSNS',
    name: 'SNS 가입',
    component: () => import('@/page/account/JoinSNS.vue'),
  },
  {
    path: '/fo/join/businessAuthentication',
    name: '기업회원 인증',
    component: () => import('@/page/account/BusinessAuthentication.vue'),
  },
  {
    path: '/fo/join/companyInfo',
    name: '소속회사 정보',
    component: () => import('@/page/account/CompanyInfo.vue'),
  },
  {
    path: '/fo/join/registrationComplete',
    name: '회원가입 완료',
    component: () => import('@/page/account/RegistrationComplete.vue'),
  },
  {
    path: '/fo/join/findID/:division',
    name: '아이디 찾기',
    component: () => import('@/page/account/FindID.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
    }
  },
  {
    path: '/fo/join/findIDComplete',
    name: '아이디찾기완료',
    component: () => import('@/page/account/FindIDComplete.vue'),
  },
  {
    path: '/fo/join/findPassword/:division',
    name: '비밀번호 찾기',
    component: () => import('@/page/account/FindPassword.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '비밀번호 찾기',
    }
  },
  {
    path: '/fo/join/emailAuthentication',
    name: '이메일 인증',
    component: () => import('@/page/account/EmailAuthentication.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '이메일 인증',
    }
  },
  {
    path: '/fo/join/resetPassword',
    name: '비밀번호 재설정',
    component: () => import('@/page/account/ResetPassword.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '비밀번호 재설정',
    }
  },
  {
    path: '/fo/join/changePhoneNumber',
    name: '휴대전화변경',
    component: () => import('@/page/account/ChangePhoneNumber.vue'),
  },
  {
    path: '/fo/join/changePassword',
    name: '비밀번호변경',
    component: () => import('@/page/account/ChangePassword.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '비밀번호변경',
    }
  },
  {
    path: '/fo/join/CheckChangePassword',
    name: '비밀번호변경확인',
    component: () => import('@/page/account/CheckChangePassword.vue'),
    meta: {
      isHideHeader: false,
      isHideBack: false,
      headerTitle: '비밀번호변경확인',
    }
  },
  {
    path: '/fo/join/companyInfo',
    name: '소속회사정보설정',
    component: () => import('@/page/account/CompanyInfo.vue'),
  },
  {
    path: '/fo/join/terms',
    name: '약관동의',
    component: () => import('@/page/account/Terms.vue')
  },
  {
    path: '/fo/leave',
    name: '회원탈퇴',
    component: () => import('@/page/account/Withdrawal.vue')
  },
  // 5일 체험권 본인인증 플로우
  // certifyType: 1001 (IDENTIFICATION) / 1002 (EMPLOYEE_NUMBER) / 1003 (CARD) / 1004 (EMAIL)
  // {
  //   path: '/fo/join/identityAuthentication/:certifyType',
  //   name: '본인인증',
  //   component: () => import('@/page/account/trial/IdentityAuthentication.vue'),
  // },
  {
    path: '/fo/join/identityAuthenticationAll',
    name: '본인인증_선택형',
    component: () => import('@/page/account/trial/IdentityAuthenticationAll.vue'),
  },
  {
    path: '/fo/join/identityAuthenticationComplete',
    name: '본인인증 정보 확인',
    component: () => import('@/page/account/trial/IdentityAuthenticationComplete.vue'),
  },
  {
      path: '/fo/join/app-link',
      name: '앱링크',
      component: () => import(`@/page/applink/RedirectPageIndex.vue`),
    },
  {
      path: '/fo/join/app-store-link',
      name: '앱스토어링크',
      component: () => import(`@/page/applink/AppStoreIndex.vue`),
    }
]
